
import { motion } from "framer-motion";

export default function Card({ title, value, icon, bg }) {
  return (
    <motion.div
      whileHover={{
        y: -10,
        scale: 1.05,
        rotateX: 6,
        rotateY: -6,
      }}
      transition={{ type: "spring", stiffness: 180, damping: 12 }}
      className={`
        ${bg}
        rounded-2xl
        p-3
        relative
        overflow-hidden
        backdrop-blur-xl
        border border-white/50
        shadow-[0_20px_60px_rgba(45,28,106,0.45)]
        hover:shadow-[0_35px_90px_rgba(45,28,106,0.7)]
        group
        cursor-pointer
      `}
      style={{ transformStyle: "preserve-3d" }}
    >
      {/* soft inner glow */}
      <div className="
        absolute inset-0
        bg-gradient-to-br
        from-white/40
        via-white/10
        to-transparent
        opacity-60
        pointer-events-none
      "/>

      {/* animated light sweep */}
      <div className="
        absolute -inset-10
        bg-gradient-to-r
        from-transparent
        via-white/30
        to-transparent
        opacity-0
        group-hover:opacity-100
        transition
        duration-700
        rotate-12
      "/>

      {/* icon bubble */}
      <div className="
        w-11 h-11
        rounded-xl
        bg-white/80
        flex items-center justify-center
        mb-3
        shadow-lg shadow-black/20
        ring-1 ring-white/50
      ">
        {icon}
      </div>

      <p className="text-sm text-gray-600">{title}</p>
      <h2 className="text-xl font-semibold tracking-tight">
        {value}
      </h2>
    </motion.div>
  );
}

